import '@mrkt/features/Platform/googleAnalytics';
import {
  Logger,
  initializeTracing,
  instrumentFetch,
  getSessionId,
} from '@mrkt/features/Platform';
import {
  currentUserLoader,
  currentUserFeaturesLoader,
} from './features/currentUser';

// Expose session id globally to allow for logging from puppeteer / automated
// monitoring.
(window as any)._SESSION_ID_ = getSessionId();

Logger.init();
instrumentFetch();
initializeTracing();
currentUserLoader.load(0); // preload user
currentUserFeaturesLoader.load(0); // preload features
